// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"cf5eaf1f","356":"9beb41ef","363":"75cb2378","413":"cfe10a3c"}[chunkId] + ".chunk.js";
};